@for (button of buttons; track button) {
  @if (!button.hidden) {
    <button
      class="x_btn x_flat"
      [ngClass]="
        button.actionName
          ? 'header-action-button-' + button.actionName
          : 'header-action-button-cancel'
      "
      [attr.e2e-attr]="
        button.e2eAttr
          ? button.e2eAttr
          : E2E_ATTRIBUTES.HEADER_ACTION_BUTTON_CANCEL
      "
      (click)="button.callback()"
      [disabled]="button.disabled"
    >
      <i [ngClass]="button.iconName ? button.iconName : 'icon-close'"></i>
    </button>
  }
}
